<section class="flight-details" aria-labelledby="flight-details-title">
  <header class="flight-details__header">
    <div class="flight-details__heading">
      <h2 class="flight-details__title" id="flight-details-title">Detalhes do voo</h2>
      <p class="flight-details__route">{{ routeLabel }}</p>
      <p class="flight-details__flights">{{ flightNumbers }}</p>
    </div>
    <button class="flight-details__close" type="button" mat-dialog-close aria-label="Fechar detalhes">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18"/>
      </svg>
    </button>
  </header>

  <ol class="timeline">
    @for (leg of legs; track $index; let i = $index) {
      <li class="timeline__leg">
        <div class="timeline__stop">
          <span class="timeline__dot" aria-hidden="true"></span>
          <div class="timeline__place">
            <strong class="timeline__code">{{ leg.originCode }}</strong>
            <span class="timeline__time">{{ leg.departureTime }}</span>
            @if (leg.originCity) { <span class="timeline__city">{{ leg.originCity }}</span> }
          </div>
        </div>

        <div class="timeline__segment">
          <span class="timeline__flight">Trecho {{ i + 1 }} · LA{{ leg.flightNumber }}</span>
          @if (leg.duration) { <span class="timeline__duration">{{ leg.duration }}</span> }
          <app-seat-availability class="timeline__seats" [items]="[leg.segment]"></app-seat-availability>
        </div>

        <div class="timeline__stop timeline__stop--arrival">
          <span class="timeline__dot" aria-hidden="true"></span>
          <div class="timeline__place">
            <strong class="timeline__code">{{ leg.destinationCode }}</strong>
            <span class="timeline__time">
              {{ leg.arrivalTime }}
              @if (leg.arrivesNextDay) { <sup class="timeline__nextday">+1</sup> }
            </span>
            @if (leg.destinationCity) { <span class="timeline__city">{{ leg.destinationCity }}</span> }
          </div>
        </div>

        @if (leg.connection) {
          <p class="timeline__connection">{{ leg.connection }}</p>
        }
      </li>
    }
  </ol>
</section>
